import { useTranslation } from 'react-i18next';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * The small "?" affordance beside a section title. This is the app's main tool for
 * explaining film-production vocabulary to producers who don't come from
 * content/story creation — every craft term we keep (Dailies, A-Roll, EDL…) should
 * carry one.
 *
 * Built on Radix rather than CSS :hover so it is keyboard-reachable and announced
 * to screen readers.
 */
export default function HelpDot({ children, className }: { children: React.ReactNode; className?: string }) {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger
        type="button"
        aria-label={t('help.what')}
        className={cn(
          'inline-flex h-[15px] w-[15px] shrink-0 items-center justify-center rounded-full',
          'border border-faint font-mono text-[10px] leading-none text-faint transition-colors',
          'hover:border-primary hover:text-primary focus-visible:outline-none',
          'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background',
          className,
        )}
      >
        ?
      </TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
}
